import type { Patient } from 'fhir/r4';
import React from 'react';
import { Card, Image, Label } from 'semantic-ui-react';
import type { FlatPatient, PatientResource } from 'types';
import { formatPhoneNumber, getImage, parseFHIRPatient } from 'utils';

type CallerCardProps = {
  handleSelectCallerCard: (selectedPatient: Patient) => void;
  patient: PatientResource;
  /** Absent until a member is picked; the `?.id` comparison below already allows it. */
  selectedCallerCard: Patient | null | undefined;
};

const CallerCard: React.FC<CallerCardProps> = ({ handleSelectCallerCard, patient, selectedCallerCard }) => {
  const flatPatient: FlatPatient = parseFHIRPatient(patient);
  const imageSrc = getImage(flatPatient.gender === 'male', flatPatient?.fullName);
  const isSelected = selectedCallerCard?.id === flatPatient.id;

  const phoneNumber =
    flatPatient.mobilePhone?.[0] || flatPatient.homePhone?.[0]
      ? formatPhoneNumber(flatPatient.mobilePhone?.[0] || flatPatient.homePhone?.[0])
      : 'N/A';

  const styles = {
    card: {
      cursor: 'pointer',
      backgroundColor: isSelected ? '#add8e6' : 'white',
      padding: '10px',
      borderRadius: '6px',
      margin: '16px 0px',
      boxShadow: '0 2px 5px rgba(0, 0, 0, 0.16), 0 2px 10px rgba(0, 0, 0, 0.12)',
      border: isSelected ? '2px solid blue' : 'none',
    },
    label: { marginTop: '3px' },
  };

  return (
    <Card link onClick={() => handleSelectCallerCard(patient)} style={styles.card}>
      <Card.Content>
        <Image floated="left" size="mini" src={`/images/${imageSrc}`} />
        <Card.Header>
          {flatPatient.firstName} {flatPatient.lastName}
        </Card.Header>
        <Card.Meta>{phoneNumber}</Card.Meta>
        <Card.Description>
          {flatPatient.isInactive && <Label color='red'>INACTIVE</Label>}
          <Label>{`${flatPatient?.genderPrefix} ${flatPatient.age}`}</Label>
          <Label>{flatPatient.dob}</Label>
          {flatPatient?.memberId && <Label>{flatPatient?.memberId}</Label>}
          <Label style={styles.label}>{flatPatient.id}</Label>
          <Label style={styles.label}>{flatPatient.org}</Label>
        </Card.Description>
      </Card.Content>
    </Card>
  );
};

export default CallerCard;
